import type { LinkType } from '@/frontend-types'
import { linkFieldsToHref } from '@/helpers/transforms'
import type { LinksGridBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import { CTAStripColumns } from '../blocks/CTAStripColumns'
import LinkColumnsBlock from '../blocks/LinkColumnsBlock'

export const LinksGridConverter: JSXConverter<SerializedBlockNode<LinksGridBlock>> = ({ node }) => {
	const { links, layout } = node.fields

	const linksData = links?.reduce((acc: LinkType[], link) => {
		const href = linkFieldsToHref(link)
		acc.push({
			label: link.text,
			href: href,
			target: link.newTab ? '_blank' : '_self',
		})
		return acc
	}, [])

	switch (layout) {
		case 'underlined':
			return <CTAStripColumns links={linksData} />
		case 'simple':
			return <LinkColumnsBlock links={linksData} />
	}
}
